import React from "react";
import TagsPage from "./TagsPage";

export default function TagsSettingsPage() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Tags</h1>
        <p className="text-muted-foreground">
          Manage tags to categorise contacts, deals, properties, and more
        </p>
      </div>
      <TagsPage />
    </div>
  );
}
